import crm from '../views/crm'

export default {
  path: '/crm',
  component: crm,
  redirect: '/crm/members',
  name: 'Crm',
  meta: {
    title: '会员管理'
  },
  children: [
    {
      path: '/crm/members',
      component: () => import('@/views/crm/Members'),
      name: 'CrmMembers',
      meta: { title: '会员列表' }
    }
  ]
}
